export interface ResendReleasePaymentHoldSearchCriteria {

    actionCode?: string[] | null,
    docNo: string | null,
    cntrNo: string | null,
    docDateFrom: Date | null,
    docDateTo: Date | null,
    status: string[] | null,
    expBookingNo: string | null,
    bookingReqSeqNo: string | null,


    [key: string]: string | string[] | number | null | undefined | Object
}

export const EMPTY_RESEND_RELEASE_PAYMENT_HOLD_SEARCH_CRITERIA: ResendReleasePaymentHoldSearchCriteria = {
    actionCode: [],
    docNo: null,
    cntrNo: null,
    docDateFrom: null,
    docDateTo: null,
    status: [],
    expBookingNo: null,
    bookingReqSeqNo: null
}
